export const themeColor='#98D2C5'
export const textColor ='#9D9D9D'
export const green='#98D2C5'
export const lightGreen= '#A9CEC6'
export const buttonTextColor='#FFFFFF'